import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import './index.css';

const headerPropTypes = {
  title: PropTypes.node.isRequired,
  subtitle: PropTypes.node,
  children: PropTypes.node,
  className: PropTypes.string,
};

function NewHeader({ title, subtitle, children, className }) {
  return (
    <div className={classnames('NewHeader__container', className)}>
      <div className="NewHeader__content">
        <div className="NewHeader__title-container">
          <p className="NewHeader__title">{title}</p>
          {subtitle && <span className="NewHeader__subtitle">{subtitle}</span>}
        </div>
        {children}
      </div>
    </div>
  );
}

NewHeader.propTypes = headerPropTypes;
NewHeader.defaultProps = {
  subtitle: null,
  children: null,
  className: null,
};

export default NewHeader;



// WEBPACK FOOTER //
// ../ui-components/components/NewHeader/index.jsx